export enum AdditionalServiceType {
  MORTGAGE = 'MORTGAGE',
  INSURANCE = 'INSURANCE',
  UTILITIES = 'UTILITIES',
  RELOCATION = 'RELOCATION',
  RENOVATION = 'RENOVATION',
  FURNITURE = 'FURNITURE',
  ALARMS = 'ALARMS',
}
